import type { TokenType } from "../odata-types.ts";
import { Expression } from "./base/Expression.ts";
import type { FilterExpression } from "./base/types.ts";

export class LogicalExpression extends Expression {
    readonly type = "logical";
    public operator: typeof TokenType.AND | typeof TokenType.OR;
    public left: FilterExpression;
    public right: FilterExpression;

    constructor(operator: typeof TokenType.AND | typeof TokenType.OR, left: FilterExpression, right: FilterExpression) {
        super();
        this.operator = operator;
        this.left = left;
        this.right = right;
    }

    stringify(): string {
        const left = this.left.stringify();
        const right = this.right.stringify();
        return `${left} ${this.operator} ${right}`;
    }

    getKey(): string {
        return `${this.left.getKey()}::${this.operator}::${this.right.getKey()}`;
    }
}
